<template>
  <v-container class="productContainer">
    <v-row>
      <v-col cols="auto">
        <v-btn class="backButton" @click="$router.go(-1)">
          <v-icon class="buttonIcon">arrow_back</v-icon>
          {{ $t("BUTTON_BACK_TO_PRODUCTS") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row wrap class="layout">
      <v-col cols="12" md="6">
        <v-img :src="product.imageUrl" class="productImage" contain></v-img>
      </v-col>
      <v-col cols="12" md="6">
        <v-row v-show="error || showAlert > 0">
          <v-col cols="12">
            <v-alert type="success" :v-show="showAlert > 0" transition="fade-transition" class="addedToBasketAlert">
              {{ $t("PRODUCT_ADDED_TO_BASKET") }}
              <router-link to="/basket" class="basketLink">{{ $t("GO_TO_BASKET") }}</router-link>
            </v-alert>
            <v-alert type="error" v-show="error" transition="fade-transition" class="addedToBasketAlert">{{
                error
              }}
            </v-alert>
          </v-col>
        </v-row>
        <div class="productDetails elevation-3">
          <v-row align-center class="header">
            <v-col cols="auto">
              <h1 class="display-1">{{ product.name }}</h1>
            </v-col>
            <v-spacer/>
            <v-col v-if="hasDiscount" cols="auto">
              <h3 class="priceTag instead">{{ formatPrice(product.setPriceInsteadOf) }}</h3>
            </v-col>
            <v-col cols="auto">
              <h3 :class="{priceTag: true, discounted: hasDiscount}">{{ formatPrice(price) }}</h3>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <h3 class="subHeading grey--text">{{ product.subHeading }}</h3>
            </v-col>
          </v-row>
          <br>
          <v-row class="description">
            <v-col>
              <p v-html="product.longDescription"></p>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer/>
            <v-col cols="auto">
              <v-btn color="primary" @click="startConfiguration">{{ $t("BUTTON_CONFIGURE_PRODUCT") }}</v-btn>
            </v-col>
            <v-spacer/>
          </v-row>
          <v-dialog v-model="configuring" content-class="configuratorDialog" scrollable>
            <v-icon @click="configuring = false" class="closeDialog">close</v-icon>
            <ProductConfigurator :product="product" @addedToBasket="addedToBasket" @error="onConfigurationError"/>
          </v-dialog>
          <!--<v-card class="filterContainer" v-show="hasImages && product.medium !== 'DOWNLOAD' && product.productType !== 'SET' && !product.imageFilter">
            <v-card-title>
              <h4 class="title">{{ $t("FILTER_SELECTION_HEADER") }}</h4>
            </v-card-title>
            <v-card-text>{{ $t("FILTER_SELECTION_TEXT") }}</v-card-text>
            <div class="content">
              <v-select
                  v-model="filter"
                  :items="availableFilters"
                  item-value="id"
                  item-text="name"/>
            </div>
          </v-card>-->
          <!-- v-row row wrap>
            <v-btn to="/" :color="continueShopping ? 'primary' : null">
              <v-icon class="buttonIcon">arrow_back</v-icon>
              {{ $t("BUTTON_CONTINUE_SHOPPING") }}
            </v-btn>
            <v-spacer/>
            <v-tooltip top :disabled="isValid">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn :disabled="! isValid" @click="addToBasket" color="primary">
                    <v-icon class="buttonIcon">shopping_cart</v-icon>
                    {{ $t("BUTTON_ADD_TO_BASKET") }}
                  </v-btn>
                </div>
              </template>
              <span>{{ $t("IMAGE_CHOOSE_ERROR") }}</span>
            </v-tooltip>
          </v-row-->
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Component from "vue-class-component";
import {
  ConfiguredImageDto,
  DetailedImageRequirementDto,
  ImageFilterDto,
  ImageRequirementDto,
  ProductDto,
  ProductMediumDto,
  ProductTypeDto
} from "@swagger";
import ImagePreview from "@/components/ImagePreview.vue";
import BasicComponent from "@/global/BasicComponent";
import SelectableImagePreview from "@/components/SelectableImagePreview.vue";
import ImageBatchSelector from "@/components/product-configuration/ImageBatchSelector.vue";
import {ImageRows} from "@/global/types";
import ProductConfigurator from "@/components/product-configuration/ProductConfigurator.vue";

@Component({
  components: {ProductConfigurator, ImageSelectionRow: ImageBatchSelector, SelectableImagePreview, ImagePreview}
})
export default class ProductDetails extends BasicComponent {

  showAlert: number = 0;
  error: string|null = null;
  continueShopping: boolean = false;
  configuring: boolean = false;
  
  created() {

  }

  mounted() {
  }

  startConfiguration() {
    this.configuring = true;
  }

  /**
   * Called when an article has been added to the basket
   */
  addedToBasket(): void {
    this.error = undefined;
    this.showAlert++;
    const data = this;
    setTimeout(function () {
      data.showAlert--
    }, 5000)
    this.continueShopping = true;
  }

  onConfigurationError(error: string): void {
    this.error = error;
  }

  get price() {
    return this.product.price; //+ (this.isDetailedConfiguration ? this.product.detailedConfigurationSurcharge : 0);
  }

  get product(): ProductDto {
    const product = this.$store.getters.product(this.$route.params.id);

    if (product) {
      this.trackPage("P: " + product.name);
    }
    return product ? product : {
      imageRequirements: [],
      detailedImageRequirements: []
    };
  }

  get discount() {
    let instead = this.product.setPriceInsteadOf;
    if (!instead) instead = this.product.price;
    return this.product.price / instead - 1;
  }

  get hasDiscount() {
    return this.discount <= -0.01; // At least 1%
  }

  get hasImages() {
    return this.product.imageRequirements && this.product.imageRequirements.length > 0;
  }

  formatDiscount(discount) {
    return `${Math.round(discount * 100)}%`
  }

}
</script>
<style scoped lang="scss">
@import "../stylesheets/Variables.scss";

.container {
  margin-top: 0 !important;
}

.productContainer {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
  max-width: 100%;
}

.backButton {
  margin-bottom: 15px;
}

.productDetails {
  background-color: white;
  padding: 15px;
  margin-bottom: 15px;

  .header {
    .col {
      &:not(:last-of-type) {
        padding-bottom: 0;
      }
    }
  }
}

.discountNote {

  padding: 0 15px;
  margin-bottom: 15px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  justify-content: center;

  .iconFlex {
    flex: 0 1 auto;

    .discountIcon {
      display: inline;
      vertical-align: center;
      color: green;
    }
  }

  p {
    font-size: 16px;
    display: inline-block;
    padding-left: 15px;
    margin-bottom: 0;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  .v-icon, p {

  }
}

.layout {
  margin-bottom: 5px;
}

.subHeading {
  font-weight: 500;
}

.description {
  margin-bottom: 15px;
}

.productImage {
  max-width: 500px;
  max-height: 500px;
  margin: 0 auto;

  @media screen and (max-height: 800px) {
    max-height: 350px;
  }
}

.productCard {
  max-width: 320px;
  margin: 4px;
  margin-right: 15px;
  display: inline-block;
  vertical-align: top;
}

.priceTag {
  color: $price-color !important;
  font-size: 20px;
  text-align: right;

  &.discounted {
    color: $price-color-discount !important;
  }

  &.instead {
    color: grey !important;
    text-decoration: line-through;
  }
}

.imageChoiceHeading {
  font-weight: normal;
}

.addedToBasketAlert {

  position: fixed;
  top: 5px;
  right: 5px;

  z-index: 1000;

  @media screen and (max-width: 470px) {
    margin: 0;
    top: 0;
    right: 0;
  }

  .basketLink {
    color: white;
    font-weight: bold;
    text-decoration: none;
  }
}

.filterContainer {
  margin-top: 15px;

  .content {
    padding: 16px;
  }
}

.configureButton {
  position: fixed;
  bottom: 10vh;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (min-width: $md) {
    left: 25%;
  }
}

</style>
<style lang="scss">
.configuratorDialog {
  position: relative;
  line-height: inherit !important;
  overflow-x: hidden;

  .closeDialog {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 24px;
    width: 24px;
    z-index: 11;
  }
}
</style>